import { useNavigate } from "react-router-dom";
import {
  faCircleDollarToSlot,
  faClipboardList,
  faLocationDot,
  faMagnifyingGlass,
  faMapPin,
  faPenToSquare,
  faRotateLeft,
  faTrash,
  faUserPlus,
  faXmark,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  ListGroup,
  Modal,
  Row,
  Table,
  FloatingLabel,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import OverlayLoader from "../../components/OverlayLoader";
import Message from "../../components/Message";
import { partnerRegister } from "../../redux/Actions/bizDevAction";
import {
  deleteUser,
  getUserDetails,
  // listUsers,
  updateHotel,
  impersonateUser,
} from "../../redux/Actions/userAction";
import { generatePassword } from "../../controllers/passwordGenerator";
import BizDevRoperts from "./BizDevRoperts";
import CommissionMonthlyReport from "../../components/CommissionMonthlyReport";
import { setActiveTab } from "../../redux/Actions/tabAcions";
import { listUsers } from "../../redux/slices/clientSlice";

const BizDev = () => {
  const navigate = useNavigate();
  let isProcessing = false;
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [message, setMessage] = useState(null);
  const [duplicateError, setDuplicateError] = useState(false);
  const [clientTotalEarnings, setClientTotalEarnings] = useState({});
  const [userToDelete, setUserToDelete] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [screenLoading, setScreenLoading] = useState(false);
  const options = { year: "numeric", month: "numeric", day: "numeric" };
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    location: "",
    accountType: "",
    // password: "",
    // confirmPassword: "",
    isPartner: true,
    commision: true,
  });

  const dispatch = useDispatch();
  // const userList = useSelector((state) => state.userList);
  // const { loading, error, users, success } = userList;

  const {
    listLoading: loading,
    partners,
    listError: error,
  } = useSelector((state) => state.client);

  // const partners =
  //   users?.length > 0 ? users.filter((user) => user.isPartner == true) : [];

  const userRegister = useSelector((state) => state.partnerRegister);
  const {
    loading: registerLoading,
    error: registerError,
    success: registerSuccess,
  } = userRegister;

  const calculateTotalEarnings = (selectedPartner) => {
    if (!selectedPartner || !selectedPartner.commisionEarned) return 0;
    const total = selectedPartner.commisionEarned.reduce(
      (total, commission) => total + commission.amount,
      0
    );
    return parseFloat(total.toFixed(2));
  };
  const handleClose = () => {
    setValidated(false);
    setShow(false);
    setMessage(null);
    setDuplicateError(false);
    setFormData({
      fullName: "",
      email: "",
      location: "",
      accountType: "",
      // password: "",
      // confirmPassword: "",
      isPartner: true,
      commision: true,
    });
  };
  const handleShow = () => {
    setShow(true);
    setValidated(false);
  };

  const handleReportsModal = () => setShowReports(false);

  const handleDeleteModal = () => setDeleteModal(false);

  const handleDelete = () => {
    if (userToDelete) {
      dispatch(deleteUser(userToDelete));
      setUserToDelete(null);
      setDeleteModal(false);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleSave = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      const existingUser = partners.find(
        (partner) => partner.email === formData.email
      );
      if (existingUser) {
        setDuplicateError(true);
      } else {
        const password = generatePassword(formData.fullName);
        dispatch(
          partnerRegister(
            formData.fullName,
            formData.email,
            formData.location,
            password,
            formData.isPartner,
            formData.commision,
            formData.accountType
          )
        );
        handleClose();
      }
    }
    setValidated(true);
  };
  const handleImpersonate = (client) => {
    if (isProcessing) return;
    isProcessing = true;
    setScreenLoading(true);
    setTimeout(() => {
      setScreenLoading(false);
      dispatch(impersonateUser(client._id, client.email, navigate));
      dispatch(setActiveTab("#dashboard"));
      isProcessing = false;
    }, 1000);
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return !isNaN(date.getTime())
      ? date.toLocaleDateString("en-US", options)
      : "Invalid Date";
  };
  useEffect(() => {
    dispatch(listUsers());
  }, [dispatch, registerSuccess]);

  const styles = {
    shadow: {
      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    },
  };
  return (
    <>
      {screenLoading ? <OverlayLoader /> : null}
      {/* ---------------------------------------- REPORTS MODAL ------------------------------------------------- */}
      <Modal
        show={showReports}
        onHide={handleReportsModal}
        backdrop="static"
        size="lg"
        // centered
      >
        <Modal.Header className="bg-primary">
          <Row className="w-100">
            <Col xs="auto" className="ms-auto p-0">
              <Button
                onClick={() => {
                  setShowReports(false);
                  setSelectedPartner(null);
                }}
              >
                <FontAwesomeIcon icon={faXmark} className=" fs-5" />
              </Button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <CommissionMonthlyReport partnerId={selectedPartner} />
        </Modal.Body>
      </Modal>
      {/* -------------------------------------- ADD NEW MODAL ----------------------------------------------------- */}
      <Modal show={show} onHide={handleClose} backdrop="static" centered>
        <Modal.Header className="bg-primary text-light">
          <Row className="w-100">
            <Col xs="auto" className="fs-4">
              Add New
            </Col>
            <Col md="auto" className="ms-auto p-0">
              <Button
                variant="outline-light p-0 px-1  m-0 border-0"
                onClick={handleClose}
              >
                <FontAwesomeIcon className="fs-4" icon={faXmark} />
              </Button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className="px-5">
          <Form noValidate validated={validated} onSubmit={handleSave}>
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Enter Name"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                This field is required*
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="Enter email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Enter a valid Email*
              </Form.Control.Feedback>
              {duplicateError ? (
                <Form.Text className="text-danger">
                  User with this email already exist
                </Form.Text>
              ) : (
                <></>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicLocation">
              <Form.Label>Address/Location</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Enter location/address"
                name="location"
                value={formData.location}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                This field is required*
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              required
              className="mb-3"
              controlId="formBasicAccountType"
            >
              <Form.Label>Stripe Account:</Form.Label>
              <Row className="justify-content-center">
                <Col md="auto" className="p-0">
                  <Form.Check
                    required
                    inline
                    label="Individual"
                    value="individual"
                    name="accountType"
                    type="radio"
                    onChange={handleInputChange}
                  />
                </Col>
                <Col md="auto">
                  <Form.Check
                    inline
                    label="Business"
                    value="business"
                    name="accountType"
                    type="radio"
                    onChange={handleInputChange}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Row className="my-3 mt-5">
              <Col xs="auto" className="ms-auto">
                <Button variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
                <Button className="ms-3 px-5" variant="success" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      {/* --------------------------------------------------- DELETE MODAL ------------------------------------------ */}
      <Modal
        show={deleteModal}
        onHide={handleDeleteModal}
        backdrop="static"
        centered
      >
        <Modal.Body className="p-4 text-center">
          <b>Are you sure you want to remove this user ?</b>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Row className="m-0 py-5">
        <Col>
          {/* --------------------------------------------------- ADD NEW BUTTON ------------------------------------------ */}
          <Row>
            <Col xs="auto" className="ms-auto me-2">
              <Button className="p-2 px-3 rounded-3" onClick={handleShow}>
                <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                Add New
              </Button>
            </Col>
          </Row>
          {/* --------------------------------------------------- TABLE ------------------------------------------ */}
          <Row className="p-3 my-2">
            <Col className="p-3 py-4 rounded-4" style={styles.shadow}>
              <Row>
                <Col sm="auto" className="me-2 fw-bold">
                  #
                </Col>
                <Col sm={1} className="fw-bold">
                  Date
                </Col>
                <Col sm={2} className="fw-bold">
                  Name
                </Col>
                <Col sm={3} className="fw-bold">
                  Email
                </Col>
                <Col sm={3} className="fw-bold">
                  Location
                </Col>
              </Row>
              <hr className="mt-3 mb-1" />
              {loading || registerLoading ? (
                <Row className="justify-content-center">
                  <Col sm="auto">
                    <Loader />
                  </Col>
                </Row>
              ) : error || registerError ? (
                <Row className="justify-content-center">
                  <Col sm="auto">
                    <Message>{error || registerError}</Message>
                  </Col>
                </Row>
              ) : (
                partners &&
                partners.length > 0 &&
                partners
                  .slice()
                  .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                  .map((partner, index) => (
                    <div key={index}>
                      <Row className="align-items-center py-2">
                        <Col sm="auto" className=" fw-bold">
                          {index + 1}.
                        </Col>
                        <Col md={1} className="p-0 text-break">
                          {new Date(partner.createdAt).toLocaleDateString(
                            "en-US",
                            options
                          )}
                        </Col>
                        <Col
                          md={2}
                          className="p-0 fw-bold text-primary text-break"
                        >
                          {partner.name}
                        </Col>
                        <Col md={3} className="p-0 text-break">
                          {partner.email}
                        </Col>
                        <Col md={2} className=" text-success p-0 text-break">
                          <FontAwesomeIcon
                            className="text-success me-2 p-0 m-0"
                            icon={faLocationDot}
                          />
                          {partner.location}
                        </Col>
                        <Col xs="auto" className="ms-auto align-items-center">
                          <Button
                            variant="outline-primary"
                            className="border-1"
                            onClick={() => {
                              setShowReports(true);
                              setSelectedPartner(partner._id);
                            }}
                          >
                            <FontAwesomeIcon icon={faClipboardList} />
                          </Button>
                          <Button
                            variant="outline-primary"
                            className="mx-2 px-2 border-1"
                            onClick={() => {
                              handleImpersonate(partner);
                            }}
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                          <Button
                            variant="outline-danger"
                            className="border-1"
                            onClick={() => {
                              setDeleteModal(true);
                              setUserToDelete(partner._id);
                            }}
                          >
                            <FontAwesomeIcon className="" icon={faTrash} />
                          </Button>
                        </Col>
                      </Row>
                      <hr className="my-1" />
                    </div>
                  ))
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default BizDev;
